import { useApi } from "@appretio/api";
import { useQuery } from "@tanstack/react-query";
import { contextSelectorQueryKeys } from "./queryKeys";

/**
 * A base hook to fetch base context options from the API.
 *
 * Note: staleTime is set to Infinity to avoid refetching.
 */
export function useBaseContextOptions({ enabled = true } = {}) {
  const client = useApi();

  return useQuery({
    queryKey: contextSelectorQueryKeys.all,
    meta: {
      errorMessage: "Failed to fetch context options."
    },
    queryFn: async () => {
      const response = await client.POST(
        "/v2/context-options/getContextOptions",
        {
          body: {
            fields: [],
            filters: {}
          }
        }
      );

      return response.data?.result ?? {};
    },
    staleTime: Infinity,
    enabled
  });
}
